
/**
 * @abstract
 */
export abstract class CustomFilter {}